import { getConfigurableTexts } from "@/api/client/configurable-texts";
import { getCompany } from "@/api/company/company-services";

export const companySlice = (set, get) => ({
  companyData: {},
  configurableTexts: [],
  companyNotFound: false,

  getCompanyData: async () => {
    try {
      const companyData = await getCompany();
      set({ companyData, companyNotFound: false });
    } catch (error) {
      if (error?.status === 404) {
        set({ companyData: {}, companyNotFound: true });
        return;
      }
      throw error;
    }
  },
  getConfigurableTexts: async () => {
    const configurableTexts = await getConfigurableTexts();
    const normalizedConfigurableTexts = Array.isArray(configurableTexts)
      ? configurableTexts
      : Array.isArray(configurableTexts?.data)
        ? configurableTexts.data
        : [];
    set({ configurableTexts: normalizedConfigurableTexts });
  },
});
